import { IoClose } from "react-icons/io5";
import { FaCheckSquare } from "react-icons/fa";

export const CATEGORY = [
    { id: 1, name: "Investor" },
    { id: 2, name: "Organization" },
    { id: 3, name: "Individual" },
    { id: 4, name: "Corporate" },
    { id: 5, name: "Group" },
    { id: 6, name: "Project" },
    { id: 7, name: "Staff" },
    { id: 8, name: "Non-profit" },
    { id: 9, name: "Core" },
    { id: 10, name: "Support" },
    { id: 11, name: "Finance" },
    { id: 12, name: "Regulatory" },
    { id: 13, name: "Education" },
    { id: 14, name: "Research" },
    { id: 15, name: "Media" },
    { id: 16, name: "Corporate" },
    { id: 17, name: "Professional" },
    { id: 18, name: "Philanthropy" },
];

export const EVENT_MASTER_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "name", title: "Name" },
    { dataIndex: "eventTypeName", title: "Event Type", render: (_text: any, record: any) => record.eventTypeReqDTO?.name || record.eventType?.name || record.eventTypeId || "-" },
    { dataIndex: "description", title: "Description" },
    { dataIndex: "severity", title: "Severity" },
];

export const EVENT_TYPE_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "name", title: "Name" },
    { dataIndex: "description", title: "Description" },
    { dataIndex: "riskLevel", title: "Risk Level" },
];

export const CARBON_PROJECT_MASTER_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "name", title: "Project Name" },
    { dataIndex: "description", title: "Description" },
    { dataIndex: "planStart", title: "Start Date", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "planEnd", title: "End Date", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "entityType", title: "Entity Type", render: (_: any, r: any) => r?.entityType?.name || r?.entityTypeId || "-" },
    { dataIndex: "opportunityType", title: "Opportunity Type", render: (_: any, r: any) => r?.opportunityType?.name || r?.opportunityTypeId || "-" },
    { dataIndex: "status", title: "Status", render: (val: any) => val ? "Active" : "Inactive" },
];

export const CARBON_SOURCE_MASTER_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "projectId", title: "Project Id" },
    { dataIndex: "latitude", title: "Latitude" },
    { dataIndex: "longitude", title: "Longitude" },
    { dataIndex: "areaHa", title: "Area (Ha)" },
    { dataIndex: "baselineCarbon", title: "Baseline Carbon" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "entityType", title: "Entity Type", render: (_: any, r: any) => r?.entityType?.name || r?.entityTypeId || "-" },
    { dataIndex: "assetRef", title: "Asset", render: (_: any, r: any) => r?.assetRef?.name || r?.assetRef?.code || r?.assetId || "-" },
    { dataIndex: "assetType", title: "Asset Type", render: (_: any, r: any) => r?.assetType?.name || r?.assetTypeId || "-" },
    { dataIndex: "opportunityType", title: "Opportunity Type", render: (_: any, r: any) => r?.opportunityType?.name || r?.opportunityTypeId || "-" },
    { dataIndex: "opportunityApplication", title: "Opp. Application", render: (_: any, r: any) => r?.opportunityApplication?.opportunityId || r?.opportunityApplicationId || "-" },
    { dataIndex: "planStart", title: "Plan Start" },
    { dataIndex: "planEnd", title: "Plan End" },
    { dataIndex: "status", title: "Status", render: (val: any) => val ? "Active" : "Inactive" },
];

export const MONITORING_BATCH_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "sourceMaster", title: "Carbon Source", render: (_: any, r: any) => r?.sourceMaster?.assetRef?.name || r?.sourceMaster?.assetRef?.code || r?.sourceMaster?.code || r?.sourceId || "-" },
    { dataIndex: "periodStart", title: "Period Start", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "periodEnd", title: "Period End", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "measuredCarbon", title: "Measured Carbon" },
    { dataIndex: "sequestration", title: "Sequestration" },
    { dataIndex: "uom", title: "UOM" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "entityType", title: "Entity Type", render: (_: any, r: any) => r?.entityType?.name || r?.entityTypeId || "-" },
    { dataIndex: "asset", title: "Asset", render: (_: any, r: any) => r?.asset?.name || r?.assetId || "-" },
    { dataIndex: "assetType", title: "Asset Type", render: (_: any, r: any) => r?.assetType?.name || r?.assetTypeId || "-" },
    { dataIndex: "opportunityType", title: "Opportunity Type", render: (_: any, r: any) => r?.opportunityType?.name || r?.opportunityTypeId || "-" },
    { dataIndex: "planStart", title: "Plan Start", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "planEnd", title: "Plan End", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "status", title: "Status", render: (val: any) => val ? "Active" : "Inactive" },
];

export const VERIFICATION_RECORD_COLUMN = [
    { dataIndex: "id", title: "Id" },
    {
        dataIndex: "monitoringBatch", title: "Monitoring Batch", render: (_: any, r: any) => {
            const b = r?.monitoringBatch;
            if (!b) return r?.batchId || "-";
            const src = b?.sourceMaster?.assetRef?.name || b?.sourceMaster?.code || "Batch";
            const ps = b?.periodStart ? String(b.periodStart).slice(0, 10) : "?";
            const pe = b?.periodEnd ? String(b.periodEnd).slice(0, 10) : "?";
            return `#${b.id} — ${src} (${ps} → ${pe})`;
        }
    },
    { dataIndex: "verifier", title: "Verifier Name", render: (_: any, r: any) => r?.verifier?.name || "-" },
    { dataIndex: "approvedQty", title: "Approved Qty" },
    { dataIndex: "bufferPercentage", title: "Buffer (%)", render: (v: any) => v ?? "-" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entityMaster?.name || r?.entity?.name || r?.monitoringBatch?.entity?.name || r?.entityId || "-" },
    { dataIndex: "entityType", title: "Entity Type", render: (_: any, r: any) => r?.entityTypeMaster?.name || r?.entityType?.name || r?.entityTypeId || "-" },
    { dataIndex: "asset", title: "Asset", render: (_: any, r: any) => r?.asset?.name || r?.assetId || "-" },
    { dataIndex: "assetType", title: "Asset Type", render: (_: any, r: any) => r?.assetType?.name || r?.assetTypeId || "-" },
    { dataIndex: "opportunityType", title: "Opportunity Type", render: (_: any, r: any) => r?.opportunityType?.name || r?.opportunityTypeId || "-" },
    { dataIndex: "planStart", title: "Plan Start", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "planEnd", title: "Plan End", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "status", title: "Status", render: (val: any) => val ? "Active" : "Inactive" },
];

export const MINTING_TRANSACTION_COLUMN = [
    { dataIndex: "id", title: "MINTTXNID" },
    { dataIndex: "vintage", title: "VINTAGE" },
    { dataIndex: "mintDate", title: "MINT DATE" },
    { dataIndex: "quantity", title: "QUANTITY" },
    { dataIndex: "registryRef", title: "REGISTRY REF" },
];

export const CARBON_INVENTORY_COLUMN = [
    { dataIndex: "id", title: "INVENTORYID" },
    { dataIndex: "projectId", title: "PROJECTID" },
    { dataIndex: "vintage", title: "VINTAGE", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "carbonInventoryStatus", title: "Carbon Inventory Status" },
    { dataIndex: "quantity", title: "QUANTITY" },
    { dataIndex: "lastUpdatedDate", title: "LAST UPDATED", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
];

export const CARBON_SALE_TRANSACTION_COLUMN = [
    { dataIndex: "id", title: "SALEID" },
    { dataIndex: "buyer", title: "BUYER" },
    { dataIndex: "saleDate", title: "DATE", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "quantity", title: "QTY" },
    { dataIndex: "price", title: "PRICE" },
    { dataIndex: "totalValue", title: "TOTAL VALUE" },
];

export const RETIREMENT_TRANSACTION_COLUMN = [
    { dataIndex: "id", title: "RETIREID" },
    { dataIndex: "retirementDate", title: "RETIREMENT DATE" },
    { dataIndex: "quantity", title: "QUANTITY" },
    { dataIndex: "reason", title: "REASON" },
    { dataIndex: "registryProof", title: "REGISTRY PROOF" },
];

export const FAMILY_OFFICE_ALLOCATION_COLUMN = [
    { dataIndex: "id", title: "ALLOCATION ID" },
    { dataIndex: "investor", title: "INVESTOR" },
    { dataIndex: "projectId", title: "PROJECT", render: (_: any, r: any) => r?.project?.name || r?.projectId || "-" },
    { dataIndex: "credits", title: "CREDITS" },
    { dataIndex: "revenueShare", title: "REVENUE SHARE (%)" },
    { dataIndex: "allocationDate", title: "DATE", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
];

export const ENTITY_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "dob",
        title: "Date of Birth/Inception",
    },
    {
        dataIndex: "entityType",
        title: "Entity Type",
    },
    {
        dataIndex: "registrationNo",
        title: "Registration No",
    },
    {
        dataIndex: "country",
        title: "Country",
    },
    {
        dataIndex: "focusArea",
        title: "Focus Area",
    },
    {
        dataIndex: "successorStatus",
        title: "Successor Status",
    },
    {
        title: "Parent Entity Type",
        dataIndex: "parentEntityType",
    },
    {
        title: "Parent Entity",
        dataIndex: "parentEntity",
    },
];

export const ENTITY_TYPE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "category",
        title: "Category",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const ENTITY_CAP_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "entity",
        title: "Entity",
    },
    {
        dataIndex: "entityType",
        title: "Entity Type",
    },
    {
        dataIndex: "shareholderEntity",
        title: "Shareholder Entity",
    },
    {
        dataIndex: "shareholderEntityType",
        title: "Shareholder Entity Type",
    },
    {
        dataIndex: "percentageHolding",
        title: "Percentage Holding",
    },
];

export const INVESTMENT_MANDATE_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const ASSET_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
];

export const ASSETS_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        dataIndex: "initialValue",
        title: "Initial Value",
    },
    {
        dataIndex: "current",
        title: "Current",
    },
    {
        dataIndex: "date",
        title: "Date",
    },
    {
        dataIndex: "healthScore",
        title: "Health Score",
    },
];


export const MENTORSHIP_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "entityMenteeName",
        title: "Mentee",
    },
    {
        dataIndex: "entityTypeMenteeName",
        title: "Mentee Typ",
    },
    {
        dataIndex: "entityMentorName",
        title: "Mentor",
    },
    {
        dataIndex: "entityTypeMentorName",
        title: "Mentor Type",
    },
    {
        dataIndex: "topic",
        title: "Topic",
    },
    {
        dataIndex: "fromDate",
        title: "From Date",
    },
    {
        dataIndex: "toDate",
        title: "To Date",
    },
    {
        dataIndex: "hours",
        title: "Hours",
    },
    {
        dataIndex: "effectivenessScore",
        title: "Effectiveness Score",
    },
];

export const SPONSOR_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "entity_name",
        title: "Entity Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "experience_years",
        title: "Experience Years",
    },
    {
        dataIndex: "gender",
        title: "Gender",
    },
    {
        dataIndex: "email",
        title: "Email",
    },
    {
        dataIndex: "assessment_score",
        title: "Assessment Score",
    },
    {
        dataIndex: "ESG_awareness_score",
        title: "ESG Awareness Score",
    },
];

export const FAMILY_OFFICE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "legacyGoal",
        title: "Legacy Goal",
    },
    {
        dataIndex: "governanceModel",
        title: "Governance Model",
    },
    {
        dataIndex: "totalAssets",
        title: "Total Assets",
    },
    {
        dataIndex: "portfolioEntities",
        title: "Portfolio Entities",
        render: (entities: any) => entities?.join(", ") || "-",  // fallback to "-" if empty
    },
    {
        dataIndex: "complianceScore",
        title: "Compliance Score",
    },
];

export const INVESTMENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        dataIndex: "amount",
        title: "Amount",
    },
    {
        dataIndex: "startDate",
        title: "Start Date",
    },
    {
        dataIndex: "expROI",
        title: "Exp ROI",
    },
    {
        dataIndex: "actualROI",
        title: "Actual ROI",
    },
    {
        dataIndex: "mandate",
        title: "Mandate",
    },
    {
        dataIndex: "familyOffice",
        title: "Family Office",
    },
];

export const AGENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Agent Id",
    },
    {
        dataIndex: "agentCode",
        title: "Agent Code",
    },

    {
        dataIndex: "agentName",
        title: "Agent Name",
    },
    {
        dataIndex: "role",
        title: "Role",
    },
    {
        dataIndex: "associatedReligion",
        title: "Associated Religion",
    },
    {
        dataIndex: "attributes",
        title: "Attributes",
    },
    {
        dataIndex: "weightage",
        title: "Weightage",
    },
    {
        dataIndex: "assessmentFunction",
        title: "Assessment Function",
    },
    {
        dataIndex: "approvalAuthority",
        title: "Approval Authority",
    },
    {
        dataIndex: "tokenInfluenceRuleId",
        title: "Token Influence Rule Id",
    },
    {
        dataIndex: "parentAgentCode",
        title: "Parent Agent Code",
    },
];

export const DOCUMENT_TYPE_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "code",
        title: "Code",
    },
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "description",
        title: "Description",
    },
    {
        dataIndex: "entityTypeMaster",
        title: "Entity Type",
    },
    {
        dataIndex: "isMandatory",
        title: "Is Mandatory",
        render: (value: any) =>
            value ? (
                <FaCheckSquare size={22} color="green" />
            ) : (
                <IoClose size={22} color="red" />
            ),
    },
    {
        dataIndex: "expiryApplicable",
        title: "Expiry Applicable",
        render: (value: any) =>
            value ? (
                <FaCheckSquare size={22} color="green" />
            ) : (
                <IoClose size={22} color="red" />
            ),
    },
    {
        dataIndex: "fileFormat",
        title: "File Format",
    },
];

export const DOCUMENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Id",
    },
    {
        dataIndex: "documentName",
        title: "Name",
    },
    {
        dataIndex: "documentNumber",
        title: "Document Number",
    },
    {
        dataIndex: "documentType",
        title: "Document Type",
    },
    {
        dataIndex: "entityMaster",
        title: "Entity Master",
    },
    {
        dataIndex: "entityTypeMaster",
        title: "Entity Type",
    },
    {
        dataIndex: "fileName",
        title: "File Name",
    },
];

export const ORGANIZATION_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Organization Id",
    },
    {
        dataIndex: "name",
        title: "Organization Name",
    },
    {
        dataIndex: "code",
        title: "Organization Code",
    },
    {
        dataIndex: "contactPerson",
        title: "Contact Person",
    },
    {
        dataIndex: "contactEmail",
        title: "Contact Email",
    },
    {
        dataIndex: "contactPhone",
        title: "Contact Phone",
    },
    {
        dataIndex: "website",
        title: "Website",
    },
    {
        dataIndex: "city",
        title: "City",
    },
    {
        dataIndex: "stateId",
        title: "State Id",
    },
    {
        key: "state",
        dataIndex: ["state", "name"],
        title: "State Name",
    },
    {
        dataIndex: "countryId",
        title: "Country Id",
    },

    {
        key: "country",
        dataIndex: ["country", "name"],
        title: "Country name",
    },


    {
        dataIndex: "dependentOrgCode",
        title: "Dependent Organization Code",
    },
    {
        dataIndex: "organizationType",
        title: "Organization Type",
    },
    {
        dataIndex: "address",
        title: "Address",
    },
];

export const USER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "mobileNo",
        dataIndex: "phoneNumber",
        title: "Mobile Number",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "role",
        dataIndex: "userRole",
        title: "Subscriber",
    },
    {
        key: "group",
        dataIndex: "userGroup",
        title: "User Group",
    },
    // {
    //     key: "package",
    //     dataIndex: "packageMaster",
    //     title: "Package Name",
    // },
    // {
    //     key: "packageType",
    //     dataIndex: "packageType",
    //     title: "Package Type",
    // }
];

export const USER_SUBSCRIBER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Subscriber Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Subscriber Name",
    },
];

export const USER_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Group Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "User Group Name",
    },
];

export const COUNTRY_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Country Id",
    },
    {
        key: "countryName",
        dataIndex: "name",
        title: "Country Name",
    },
];
export const STATE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "State Id",
    },
    {
        key: "countryName",
        dataIndex: ["country", "name"],
        title: "Country Name",
    },
    {
        key: "stateName",
        dataIndex: "name",
        title: "State Name",
    },
];

export const RISK_ASSESSMENT_LOG_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Id",
    },
    {
        key: "assetName",
        dataIndex: "assetName",
        title: "Asset Name",
    },
    {
        key: "assetType",
        dataIndex: "assetType",
        title: "Asset Type",
    },
    {
        key: "entityName",
        dataIndex: "entityName",
        title: "Entity Name"
    },
    {
        key: "entityType",
        dataIndex: "entityType",
        title: "Entity Type"
    },
    {
        key: "opportunityName",
        dataIndex: "opportunityName",
        title: "Opportunity Name"
    },
    {
        key: "opportunityType",
        dataIndex: "opportunityType",
        title: "Opportunity Type"
    },
    // {
    //     key: "llmReqAsset",
    //     dataIndex: "llmReqAsset",
    //     title: "LLM Req Asset",
    // },
    // {
    //     key: "llmResAsset",
    //     dataIndex: "llmResAsset",
    //     title: "LLM Res Asset"
    // },
    // {
    //     key: "llmReqEntity",
    //     dataIndex: "llmReqEntity",
    //     title: "LLM Req Entity"
    // },
    // {
    //     key: "llmResEntity",
    //     dataIndex: "llmResEntity",
    //     title: "LLM Res Entity"
    // },
    {
        key: "parentEntityName",
        dataIndex: "parentEntityName",
        title: "Parent Entity Name"
    },
    {
        key: "source",
        dataIndex: "source",
        title: "Source"
    },
    {
        key: "user",
        dataIndex: "user",
        title: "User"
    }
];

export const OPPORTUNITY_TYPE_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "code",
        dataIndex: "code",
        title: "Code",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "sdgGoals",
        dataIndex: "sdgGoals",
        title: "SDG Goals",
        render: (value: any) => value?.join(", "),
    },
    {
        key: "investmentMandateType",
        dataIndex: ["investmentMandateType", "name"],
        title: "Investment Mandate Type",
    },
    {
        key: "sector",
        dataIndex: "sector",
        title: "Sectors",
        render: (value: any) => value?.join(", "),
    },
    {
        key: "remarks",
        dataIndex: "remarks",
        title: "Remarks",
    }
];

export const OPPORTUNITY_MASTER_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "code",
        dataIndex: "code",
        title: "Code",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "description",
        dataIndex: "description",
        title: "Description",
    },
    {
        key: "opportunityProvider",
        dataIndex: "opportunityProvider",
        title: "Provider",
    },
    {
        key: "opportunityStartDate",
        dataIndex: "opportunityStartDate",
        title: "Start Date",
    },
    {
        key: "opportunityEndDate",
        dataIndex: "opportunityEndDate",
        title: "End Date",
    },
    {
        key: "opportunityStatus",
        dataIndex: "opportunityStatus",
        title: "Opportunity Status",
    },
    {
        key: "opportunityType",
        dataIndex: ["opportunityType", "name"],
        title: "Opportunity Type",
    },
    {
        key: "eventVenue",
        dataIndex: "eventVenue",
        title: "Event Venue",
    },
    {
        key: "eventType",
        dataIndex: "eventType",
        title: "Event Type",
    },
    {
        key: "criteria",
        dataIndex: "criteria",
        title: "Criteria (JSON)",
    },
    {
        key: "assetType",
        dataIndex: ["assetType", "name"],
        title: "Asset Type",
    },
    {
        key: "assets",
        dataIndex: ["assets", "name"],
        title: "Assets",
    },
    {
        key: "quantity",
        dataIndex: "quantity",
        title: "Quantity",
    },
    {
        key: "uom",
        dataIndex: "uom",
        title: "UOM",
    },
    {
        key: "remarks",
        dataIndex: "remarks",
        title: "Remarks",
    },
    {
        key: "user",
        dataIndex: ["user", "username"],
        title: "User",
    },
    {
        title: "Entity Type",
        dataIndex: ["entityTypeMaster", "name"],
        key: "entityTypeMaster"
    },
    {
        key: "entity",
        dataIndex: ["entityMaster", "name"],
        title: "Entity",
    }

];

export const OPPORTUNITY_APPLICATION_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Applicant Name",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "phoneNumber",
        dataIndex: "phoneNumber",
        title: "Phone Number",
    },
    {
        key: "entityMaster",
        dataIndex: ["entityMaster", "name"],
        title: "Entity",
    },
    {
        key: "entityTypeMaster",
        dataIndex: ["entityTypeMaster", "name"],
        title: "Entity Type",
    },
    {
        key: "opportunityType",
        dataIndex: ["opportunityType", "name"],
        title: "Opportunity Type",
    },
    {
        key: "source",
        dataIndex: "source",
        title: "Source",
    },
    {
        key: "followupDetails",
        dataIndex: "followupDetails",
        title: "Follow-up Details",
    },
    {
        key: "followupDate",
        dataIndex: "followupDate",
        title: "Follow-up Date",
    },
    {
        key: "remark",
        dataIndex: "remark",
        title: "Remark",
    },
    // {
    //     key: "llmResponse",
    //     dataIndex: "llmResponse",
    //     title: "LLM Response",
    // },
    {
        key: "opportunityCode",
        dataIndex: "opportunityCode",
        title: "Opportunity Code",
    },
    {
        key: "financeTransactionCode",
        dataIndex: "financeTransactionCode",
        title: "Finance Transaction Code",
    },
    {
        key: "user",
        dataIndex: ["user", "username"],
        title: "User",
    },
    {
        key: "aiDecision",
        dataIndex: "aiDecision",
        title: "AI Decision",
    },
];

export const OPPORTUNITY_APPLICANT_INTERVIEW_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Applicant Name",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "phoneNumber",
        dataIndex: "phoneNumber",
        title: "Phone Number",
    },
    {
        key: "entityMaster",
        dataIndex: ["entityMaster", "name"],
        title: "Entity",
    },
    {
        key: "entityTypeMaster",
        dataIndex: ["entityTypeMaster", "name"],
        title: "Entity Type",
    },
    {
        key: "opportunityType",
        dataIndex: ["opportunityType", "name"],
        title: "Opportunity Type",
    },
    {
        key: "opportunityApplication",
        dataIndex: ["opportunityApplication", "name"],
        title: "Opportunity Application",
    },
    {
        key: "source",
        dataIndex: "source",
        title: "Source",
    },
    {
        key: "followupDetails",
        dataIndex: "followupDetails",
        title: "Follow-up Details",
    },
    {
        key: "followupDate",
        dataIndex: "followupDate",
        title: "Follow-up Date",
    },
    {
        key: "remark",
        dataIndex: "remark",
        title: "Remark",
    },
    {
        key: "llmResponse",
        dataIndex: "llmResponse",
        title: "LLM Response",
    },
    {
        key: "financeTransactionCode",
        dataIndex: "financeTransactionCode",
        title: "Finance Transaction Code",
    },
    {
        key: "user",
        dataIndex: ["user", "username"],
        title: "User",
    },
];

export const OPPORTUNITY_ALLOCATION_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    // {
    //     key: "opportunityCode",
    //     dataIndex: "opportunityCode",
    //     title: "Opportunity Code",
    // },
    {
        key: "opportunity",
        dataIndex: ["opportunity", "name"],
        title: "Opportunity Name",
    },
    {
        key: "opportunityAllocatedBy",
        dataIndex: ["opportunityAllocatedBy", "name"],
        title: "Allocated By",
    },
    {
        key: "entityTypeAllocatedBy",
        dataIndex: ["entityTypeAllocatedBy", "name"],
        title: "Allocator Type",
    },
    {
        key: "opportunityAllocationTo",
        dataIndex: ["opportunityAllocationTo", "name"],
        title: "Allocated To",
    },
    {
        key: "entityTypeAllocatedTo",
        dataIndex: ["entityTypeAllocatedTo", "name"],
        title: "Allocated To Type",
    },
    {
        key: "opportunityFor",
        dataIndex: "opportunityFor",
        title: "Opportunity For",
    },
    {
        key: "opportunityAllocationDate",
        dataIndex: "opportunityAllocationDate",
        title: "Allocation Date",
    },
    {
        key: "opportunityAllocationStatus",
        dataIndex: "opportunityAllocationStatus",
        title: "Allocation Status",
    },
    {
        key: "panelApprovalStatus",
        dataIndex: "panelApprovalStatus",
        title: "Panel Approval Status",
    },
    {
        key: "panelReviewDate",
        dataIndex: "panelReviewDate",
        title: "Panel Review Date",
    },
    {
        key: "memberInterviewRecords",
        dataIndex: ["memberInterviewRecords", "id"],
        title: "Interview Record ID",
    },
    {
        key: "allocationType",
        dataIndex: "allocationType",
        title: "Allocation Type",
    },
    {
        key: "opportunityAllocationRemark",
        dataIndex: "opportunityAllocationRemark",
        title: "Remarks",
    },
    {
        key: "memberRole",
        dataIndex: "memberRole",
        title: "Member Role",
    },
    {
        key: "financeTransactionCode",
        dataIndex: "financeTransactionCode",
        title: "Finance Transaction Code",
    },
    {
        key: "user",
        dataIndex: ["user", "username"],
        title: "User",
    },
    {
        key: "organizationEntity",
        dataIndex: ["organizationEntity", "name"],
        title: "Organization Entity",
    },
];

export const MEMBER_INTERVIEW_RECORD_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        key: "opportunity",
        dataIndex: ["opportunity", "name"],
        title: "Opportunity",
    },
    {
        key: "member",
        dataIndex: ["member", "name"],
        title: "Member",
    },
    {
        key: "entityType",
        dataIndex: ["entityType", "name"],
        title: "Entity Type",
    },
    {
        key: "interviewedBy",
        dataIndex: ["interviewedBy", "name"],
        title: "Interviewed By",
    },
    {
        key: "entityTypeInterviewer",
        dataIndex: ["entityTypeInterviewer", "name"],
        title: "Interviewer Type",
    },
    {
        key: "interviewDate",
        dataIndex: "interviewDate",
        title: "Interview Date",
    },
    {
        key: "interviewType",
        dataIndex: "interviewType",
        title: "Interview Type",
    },
    {
        key: "interviewScore",
        dataIndex: "interviewScore",
        title: "Score",
    },
    {
        key: "interviewAssessment",
        dataIndex: "interviewAssessment",
        title: "Assessment",
    },
    {
        key: "panelDecision",
        dataIndex: "panelDecision",
        title: "Panel Decision",
    },
    {
        key: "remarksFromPanel",
        dataIndex: "remarksFromPanel",
        title: "Panel Remarks",
    },
    {
        key: "interviewVideoLink",
        dataIndex: "interviewVideoLink",
        title: "Video Link",
    },
    {
        key: "opportunityCode",
        dataIndex: "opportunityCode",
        title: "Opportunity Code",
    },
    {
        key: "financeTransactionCode",
        dataIndex: "financeTransactionCode",
        title: "Finance Transaction Code",
    },
    {
        key: "user",
        dataIndex: ["user", "username"],
        title: "User",
    },
    {
        key: "organizationEntity",
        dataIndex: ["organizationEntity", "name"],
        title: "Organization Entity",
    },
];

export const OVERVIEW_DASHBOARD_COLUMNS = [
    {
        key: "id",
        dataIndex: "id",
        title: "ID",
    },
    {
        dataIndex: "entity",
        title: "Entity",
    },
    {
        dataIndex: "entityType",
        title: "Type",
    },
    {
        dataIndex: "health",
        title: "Health",
    },
    {
        dataIndex: "action",
        title: "Action",
    },
];

export const SOVEREIGN_EVENT_LEDGER_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { key: "user", title: "User", render: (_text: any, record: any) => record.user?.username || record.userId || "-" },
    { key: "actionDate", dataIndex: "actionDate", title: "Action Date", render: (val: any) => val ? val.substring(0, 10) : "-" },
    { key: "eventType", title: "Event Type", render: (_text: any, record: any) => record.eventType?.name || record.eventTypeId || "-" },
    { key: "event", title: "Event", render: (_text: any, record: any) => record.event?.name || record.eventId || "-" },
    { key: "entity", title: "Entity", render: (_text: any, record: any) => record.entity?.name || record.entityId || "-" },
    { key: "asset", title: "Asset", render: (_text: any, record: any) => record.asset?.name || record.assetId || "-" },
    { key: "parentEntity", title: "Parent Entity", render: (_text: any, record: any) => record.parentEntity?.name || record.parentEntityId || "-" },
    { dataIndex: "drStrategyType", title: "DR Strategy Type", render: (val: any) => val || "-" },
    { dataIndex: "drChosenAsset", title: "DR Chosen Asset", render: (val: any) => val || "-" },
    { dataIndex: "region", title: "Region", render: (val: any) => val || "-" },
    { dataIndex: "costImplications", title: "Cost Implications", render: (val: any) => val || "-" },
    { dataIndex: "anticipatedLoss", title: "Anticipated Loss", render: (val: any) => val || "-" },
    { dataIndex: "remark", title: "Remark", render: (val: any) => val || "-" },
];

export const SPECIES_REGISTRY_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "commonName", title: "Common Name" },
    { dataIndex: "carbonSequestrationRate", title: "Sequestration Rate (CO2/yr/unit)" },
    { dataIndex: "nativeStatus", title: "Native Status", render: (v: any) => v ? "Native" : "Non-native" },
    { dataIndex: "regulatedFactor", title: "Regulated Factor" },
    { dataIndex: "status", title: "Status", render: (v: any) => v ? "Active" : "Inactive" },
];

export const METHOD_LIBRARY_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "brsrMetricCode", title: "BRSR Metric Code" },
    { dataIndex: "lastVerifiedBy", title: "Verified By" },
    { dataIndex: "isActive", title: "Is Active", render: (v: any) => v ? "Yes" : "No" },
    { dataIndex: "status", title: "Status", render: (v: any) => v ? "Active" : "Inactive" },
];

export const RISK_MATERIALITY_LOG_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "asset", title: "Asset", render: (_: any, r: any) => r?.asset?.name || r?.assetId || "-" },
    { dataIndex: "project", title: "Project", render: (_: any, r: any) => r?.project?.projectName || r?.projectId || "-" },
    { dataIndex: "brsrPrinciple", title: "BRSR Principle" },
    { dataIndex: "severity", title: "Severity" },
    { dataIndex: "riskStatus", title: "Risk Status" },
    { title: "Risk Assessment", dataIndex: "riskAssessment", key: "riskAssessment" },
    { title: "Contingency Plan", dataIndex: "contingencyPlan", key: "contingencyPlan" },
    { title: "Corrective Action", dataIndex: "correctiveAction", key: "correctiveAction" },
    { title: "Preventive Action", dataIndex: "preventiveAction", key: "preventiveAction" },
    { title: "Remarks", dataIndex: "remarks", key: "remarks" },
];


export const EMISSIONS_LEDGER_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "asset", title: "Asset", render: (_: any, r: any) => r?.asset?.name || r?.assetId || "-" },
    { dataIndex: "project", title: "Project", render: (_: any, r: any) => r?.project?.projectName || r?.projectId || "-" },
    { dataIndex: "scopeType", title: "Scope" },
    { dataIndex: "quantity", title: "Quantity" },
    { dataIndex: "emissionFactor", title: "Emission Factor", render: (_: any, r: any) => r?.emissionFactor?.brsrMetricCode || r?.emissionFactorId || "-" },
    { dataIndex: "entryTimestamp", title: "Timestamp", render: (v: any) => v ? String(v).slice(0, 16).replace('T', ' ') : "-" },
    { dataIndex: "satelliteReadingConsumption", title: "Satellite Reading" },
    { dataIndex: "auditTestConsumption", title: "Audit Test" },
    { dataIndex: "satelliteImageEvidence", title: "Satellite Evidence" },
    { dataIndex: "auditorEvidence", title: "Auditor Evidence" },
    { title: "Remarks", dataIndex: "remarks", key: "remarks" },

];

export const AUDIT_DISCLOSURE_SNAPSHOT_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "project", title: "Project", render: (_: any, r: any) => r?.project?.projectName || r?.projectId || "-" },
    { dataIndex: "reportPeriod", title: "Period", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "auditorSignHash", title: "Audit Hash" },
    { dataIndex: "status", title: "Status", render: (v: any) => v ? "Frozen" : "Draft" },
];

export const CARBON_PROJECT_COLUMNS = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "projectName", title: "Project Name" },
    { dataIndex: "entity", title: "Entity", render: (_: any, r: any) => r?.entity?.name || r?.entityId || "-" },
    { dataIndex: "asset", title: "Asset", render: (_: any, r: any) => r?.asset?.name || r?.assetId || "-" },
    { dataIndex: "species", title: "Species", render: (_: any, r: any) => r?.species?.commonName || r?.speciesId || "-" },
    { dataIndex: "startDate", title: "Start Date", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "projectStatus", title: "Status" },
];

export const EMISSION_FACTOR_COLUMN = [
    { dataIndex: "id", title: "Id" },
    { dataIndex: "factorName", title: "Factor Name" },
    { dataIndex: "factorValue", title: "Value" },
    { dataIndex: "unit", title: "Unit" },
    { dataIndex: "authority", title: "Authority" },
    { dataIndex: "validityStart", title: "Validity Start", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "validityEnd", title: "Validity End", render: (v: any) => v ? String(v).slice(0, 10) : "-" },
    { dataIndex: "factorVersion", title: "Version" },
    { dataIndex: "status", title: "Status", render: (v: any) => v ? "Active" : "Inactive" },
    { title: "Remarks", dataIndex: "remarks", key: "remarks" },

];